// ContextFilterAndSort.js
import React, { useState } from "react";
import {
  Menu,
  MenuItem,
  TextField,
  IconButton,
  Divider,
  Box,
  Typography,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import CheckIcon from "@mui/icons-material/Check";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";

const ContextFilterAndSort = ({
  options,
  selectedOption,
  onSortChange,
  placeholder,
  searchValue,
  onSearchChange,
  showSort = false,
  showSearch = false,
}) => {
  const theme = useTheme();
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");

  const dropdownOptions = options
    ?.filter((option) =>
      option.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .map((option, index) => ({
      key: index,
      text: option,
      value: option,
    }));

  const handleFilterOpen = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleFilterChange = (value) => {
    onSortChange(value);
    handleFilterClose();
  };

  const handleSearchTermChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
		<div style={{ display: "flex", alignItems: "center", width: "100%" }}>
			{showSearch} {showSort}
			{showSearch && (
				<TextField
					variant="outlined"
					size="small"
					placeholder={placeholder}
					value={searchValue}
					onChange={(e) => onSearchChange(e.target.value)}
					slotProps={{
						input: {
							endAdornment: (
								<Box display="flex">
									<IconButton marginRight="-2px">
										<SearchIcon />
									</IconButton>
									{showSort && (
										<div>
											<IconButton onClick={handleFilterOpen}>
												<FilterListIcon />
											</IconButton>
											<Menu
												anchorEl={filterAnchorEl}
												open={Boolean(filterAnchorEl)}
												onClose={handleFilterClose}>
												<TextField
													variant="outlined"
													size="small"
													placeholder="Search options..."
													value={searchTerm}
													onChange={handleSearchTermChange}
													autoFocus
													style={{ margin: "8px" }}
												/>
												<Divider />
												<Typography variant="subtitle1" style={{ padding: "8px 16px" }}>
													Sort Options
												</Typography>
												<Divider />
												{dropdownOptions?.length > 0 ? (
													dropdownOptions?.map((option) => (
														<MenuItem
															key={option.value}
															onClick={() => handleFilterChange(option.value)}
															style={{
																fontWeight:
																	option.value === selectedOption
																		? theme.typography.fontWeightMedium
																		: "normal",
																backgroundColor:
																	option.value === selectedOption
																		? "#e8e8e8"
																		: "inherit",
															}}>
															{option.value === selectedOption && (
																<CheckIcon
																	fontSize="small"
																	style={{
																		marginRight: "8px",
																		color: theme.palette.primary.main,
																	}}
																/>
															)}
															{option.text}
														</MenuItem>
													))
												) : (
													<MenuItem disabled>No results found</MenuItem>
												)}
											</Menu>
										</div>
									)}
								</Box>
							),
						},
					}}
					sx={{
						"& .MuiInputBase-root": {
							paddingRight: "2px", // Ensure there's no extra padding in the input field itself
						},
						width: "100%",
					}}
				/>
			)}
		</div>
  );
};

ContextFilterAndSort.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  selectedOption: PropTypes.string,
  onSortChange: PropTypes.func,
  placeholder: PropTypes.string,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  onResultSelect: PropTypes.func,
  showSort: PropTypes.bool,
  showSearch: PropTypes.bool,
};

ContextFilterAndSort.defaultProps = {
  selectedOption: "",
  placeholder: "Search...",
  showSort: true,
  showSearch: true,
};

export default ContextFilterAndSort;
